import { Grid, Typography } from "@mui/material";
import {
  AutocompleteInput,
  FormDataConsumer,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { doctoralRequests } from "api/doctoralApi";

const ProgramStructureSection = () => (
  <Grid container spacing={2}>
    <FormDataConsumer>
      {({ formData }) => (
        <>
          <Grid item xs={12} md={4}>
            <ReferenceInput
              source="structuralUnitId"
              reference={administrationRequests.getStructuralUnitsSelect()}
            >
              <AutocompleteInput
                label="Факултет"
                optionText="name"
                validate={required("Задължително")}
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
          {formData?.structuralUnitId ? (
            <Grid item xs={12} md={4}>
              <ReferenceInput
                source="departmentId"
                reference={administrationRequests.getDepartmentsSelect()}
                filter={{ StructuralUnitId: formData.structuralUnitId }}
              >
                <AutocompleteInput
                  label="Катедра"
                  optionText="name"
                  validate={required("Задължително")}
                  filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  fullWidth
                />
              </ReferenceInput>
            </Grid>
          ) : null}
          <Grid item xs={12} md={4}>
            <ReferenceInput
              source="doctoralProgramId"
              reference={doctoralRequests.getDoctoralProgramsSelect()}
            >
              <AutocompleteInput
                label="Докторантска програма"
                optionText={record => record?.name ?? ""}
                validate={required("Задължително")}
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
        </>
      )}
    </FormDataConsumer>
    <Grid item xs={12} md={4}>
      <ReferenceInput
        source="instructionLanguageId"
        reference={administrationRequests.getInstructionLanguagesSelect()}
      >
        <SelectInput
          label="Език на обучение"
          validate={required("Задължително")}
          fullWidth
        />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="personId"
        label="ЕГН/ЛНЧ"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <Typography variant="caption" color="textSecondary" display="block">
        Форма на обучение
      </Typography>
      <Typography>Свободно</Typography>
    </Grid>
  </Grid>
);

export default ProgramStructureSection;
